// extracted by mini-css-extract-plugin
export default {"assigneesOuter":"index-module__Ee76u","avatarContainer":"index-module__G62Ro","firstOverlap":"index-module__IRXPZ","secondOverlap":"index-module__lKKzL"};